// components/About.js
import React from 'react';
import {Button, Container, Grid, Typography} from '@mui/material';

function About() {
    return (
        <Container id="home" className="home" style={{paddingTop: '2rem', paddingBottom: '2rem'}}>
            <Grid container spacing={4} alignItems="center">
                <Grid item xs={12} md={7}>
                    <Typography variant="body1" paragraph>
                        The town of Ariyalur in Tamil Nadu, India, is home to the <strong>Shri Anjaneya Temple</strong>,
                        dedicated to the
                        worship of Lord Hanuman. With a history spanning more than a century, the temple has long been a
                        place of devotion, drawing worshippers from different parts of the world.
                    </Typography>

                    <Typography variant="body1" paragraph>
                        The temple was <strong>consecrated on August 1st, 1918, by Shri Periaswamy Iyer</strong>,
                        affectionately known as
                        Ariyalur Appa. Hanuman Jayanthi, the temple’s annual festival marking the birth of Lord Hanuman,
                        was first celebrated here on December 20th, 1930, following the birth of Shri Guruswamy Iyer,
                        the son of Shri Periaswamy Iyer. Since then, the temple has observed <strong>94 consecutive
                        Hanuman
                        Jayanthi</strong> celebrations. Shri Periaswamy Iyer himself coordinated the first 20
                        celebrations, after
                        which Shri Guruswamy Iyer managed the festival up to the 70th Hanuman Jayanthi. In addition to
                        his service to the temple, Shri Guruswamy Iyer was also a Chief Engineer at Neyveli Lignite
                        Corporation India Ltd, as well as a Landscape Architect and Horticulturist. From the 71st
                        Hanuman Jayanthi onwards, the celebrations have been guided by his wife, Smt. Savithri
                        Guruswamy, a Sanskrit scholar and hereditary member of the temple, with the help and
                        coordination of their son Shri Rajaseshadri, who is a Mining Geologist by profession.
                    </Typography>

                    <Typography variant="body1" paragraph>
                        <strong>Hanuman Jayanthi</strong> at the Ariyalur Shri Anjaneya Temple is celebrated annually in
                        the Tamil month
                        of Margazhi (Dhanur Maadham) on <strong>Moola Nakshathiram</strong>. Since Hanuman is a
                        Chiranjeevi (immortal),
                        his birth is observed on his star Moolam during Margazhi, a tradition that is distinctively
                        special to this temple. The festival includes several important events that invite the
                        participation of all devotees, such as <strong>Pandakaatchi, Veedhi Vizha, and Hanuman
                        Darbar</strong>. These
                        traditions form the core of the celebration and strengthen the sense of devotion among
                        worshippers.
                    </Typography>

                    <Typography variant="body1" paragraph>
                        In addition to Hanuman Jayanthi, the temple also observes other annual festivals
                        including <strong>Vishu
                        (Tamil New Year), Aadi Moolam Mahotsavam, Tula Amavasya, and Vinayagar Chaturthi</strong>. Each
                        occasion
                        is marked with rituals and gatherings that reinforce the temple’s role as a center of both
                        spiritual practice and cultural continuity.
                    </Typography>

                    <Typography variant="body1" paragraph>
                        The temple’s origins are closely tied to a significant event in the early 19th century. Shri
                        Periaswamy Iyer, guided by a vision, was directed by Lord Hanuman to excavate a particular site,
                        now known as the Nandavanam or temple garden. At this site, he discovered a sacred deity, which
                        is now enshrined within the temple. The presence of Lord Hanuman as a Swayambhu, or
                        self-manifested form, is regarded as a central spiritual feature of the temple.
                    </Typography>

                    <Typography variant="body1" paragraph>
                        Ariyalur Appa’s devotion and vision gave rise to a temple that has withstood the test of time
                        for over a hundred years. The Shri Anjaneya Temple continues to serve as a place of prayer,
                        tradition, and spiritual connection, standing as a symbol of enduring faith and heritage.
                    </Typography>
                </Grid>
                <Grid item xs={12} md={5}>
                    <img src={require("../../assets/about.jpg")} alt="Temple"
                         style={{width: '100%', height: 'auto'}}/>
                </Grid>
            </Grid>
        </Container>
    );
}

export default About;